import { render, staticRenderFns } from "./onlinebooking.vue?vue&type=template&id=3046bc2a"
import script from "./onlinebooking.vue?vue&type=script&lang=js"
export * from "./onlinebooking.vue?vue&type=script&lang=js"
import style0 from "../assets/online_booking.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/all.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../assets/base.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "../assets/icons.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "../assets/interaction.css?vue&type=style&index=4&prod&lang=css&external"
import style5 from "./onlinebooking.vue?vue&type=style&index=5&id=3046bc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports